import React from 'react';
import { Header } from '../components/Header';
import { OfferHero } from '../components/OfferHero';
import { ProblemSolution } from '../components/ProblemSolution';
import { Modules } from '../components/Modules';
import { Benefits } from '../components/Benefits';
import { Trainers } from '../components/Trainers';
import { ForWhom } from '../components/ForWhom';
import { PricingFull } from '../components/PricingFull';
import { OfferTestimonials } from '../components/OfferTestimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { SectionDivider } from '../components/ui';
import { CTAProvider } from '../components/CTAContext';
const navLinks = [{
  label: 'Module',
  target: 'module'
}, {
  label: 'Beneficii',
  target: 'beneficii'
}, {
  label: 'Despre noi',
  target: 'despre'
}, {
  label: 'Prețuri',
  target: 'pricing'
}, {
  label: 'Întrebări',
  target: 'faq'
}];
export const PrezentareCompleta = () => {
  return <CTAProvider config={{
    mode: 'scroll',
    label: 'Click aici pentru înscriere!',
    target: 'pricing'
  }} data-id="element-535">
      <div className="min-h-screen bg-navy text-textLight font-sans selection:bg-gold/30 selection:text-white" data-id="element-536">
        <Header links={navLinks} enrollTarget="pricing" data-id="element-537" />
        <OfferHero data-id="element-538" />
        <SectionDivider data-id="element-539" />
        <ProblemSolution data-id="element-540" />
        <SectionDivider data-id="element-541" />
        <Modules data-id="element-542" />
        <SectionDivider data-id="element-543" />
        <Benefits data-id="element-544" />
        <SectionDivider data-id="element-545" />
        <Trainers data-id="element-546" />
        <SectionDivider data-id="element-547" />
        <ForWhom data-id="element-548" />
        <SectionDivider data-id="element-549" />
        <PricingFull data-id="element-550" />
        <OfferTestimonials data-id="element-551" />
        <SectionDivider data-id="element-552" />
        <FAQ data-id="element-553" />
        <Footer data-id="element-554" />
      </div>
    </CTAProvider>;
};